/** Quotable Q&A for humans + FAQPage schema (AIEO / AI search). */
export const faqs = [
  {
    q: {
      en: 'What does B-Code specialize in?',
      ar: 'بماذا تتخصص B-Code؟',
    },
    a: {
      en: 'B-Code specializes in web development, Odoo ERP implementation, and custom software for growing companies. We focus on reliable delivery, clear communication, and systems teams actually use.',
      ar: 'تتخصص B-Code في تطوير الويب وتنفيذ أنظمة أودو والبرمجيات المخصصة للشركات النامية، مع تركيز على التسليم الموثوق والتواصل الواضح والأنظمة التي يعتمدها الفريق فعلياً.',
    },
  },
  {
    q: {
      en: 'Do you build and customize Odoo ERP systems?',
      ar: 'هل تبنون وتخصصون أنظمة أودو ERP؟',
    },
    a: {
      en: 'Yes. We implement and customize Odoo for real operational workflows — including process design, integrations, and a clean web presence when the brand needs one.',
      ar: 'نعم. ننفّذ ونخصص أودو ليتوافق مع سير العمل التشغيلي الحقيقي، بما يشمل تصميم العمليات والتكاملات وحضوراً رقمياً واضحاً عند الحاجة.',
    },
  },
  {
    q: {
      en: 'Can B-Code redesign or rebuild an existing company website?',
      ar: 'هل يمكن لفريق B-Code إعادة تصميم أو بناء موقع الشركة الحالي؟',
    },
    a: {
      en: 'Yes. We redesign and rebuild marketing sites and web apps with performance, conversion, and maintainability in mind — often alongside backend or Odoo work.',
      ar: 'نعم. نعيد تصميم وبناء المواقع التسويقية وتطبيقات الويب مع التركيز على الأداء والتحويل وسهولة الصيانة، وغالباً بالتوازي مع أعمال الخلفية أو أودو.',
    },
  },
  {
    q: {
      en: 'Do you work with Arabic and English projects?',
      ar: 'هل تعملون على مشاريع بالعربية والإنجليزية؟',
    },
    a: {
      en: 'Yes. We deliver bilingual experiences and collaborate comfortably in Arabic and English across discovery, design, and launch.',
      ar: 'نعم. نقدّم تجارب ثنائية اللغة ونتعامل بسلاسة بالعربية والإنجليزية عبر مراحل الاستكشاف والتصميم والإطلاق.',
    },
  },
  {
    q: {
      en: 'How do I start a project with B-Code?',
      ar: 'كيف أبدأ مشروعاً مع B-Code؟',
    },
    a: {
      en: 'Share a short brief via the contact form or email — website, Odoo, or custom software. We reply with next steps, scope options, and a clear path to kickoff.',
      ar: 'شاركنا موجزاً عبر نموذج التواصل أو البريد — موقعاً أو أودو أو برنامجاً مخصصاً — وسنرد بالخطوات التالية وخيارات النطاق ومسار واضح للانطلاق.',
    },
  },
];
